export default "/images/Equine_full.svg?952be8aaaa3ab2ad338573d0b84d5716";